import React from 'react';
import './AboutSection.css';

const FEATURES = [
  {
    icon: 'fa-solid fa-book-open-reader',
    title: 'Vast Collection',
    desc: 'Over 50,000 books, journals, and research papers across every discipline.',
  },
  {
    icon: 'fa-solid fa-wifi',
    title: 'Digital Access',
    desc: 'Access e-books, online databases, and digital archives from anywhere, anytime.',
  },
  {
    icon: 'fa-solid fa-chalkboard-user',
    title: 'Expert Guidance',
    desc: 'Our trained librarians assist students and researchers with finding the right resources.',
  },
  {
    icon: 'fa-solid fa-clock',
    title: 'Extended Hours',
    desc: 'Open early to late, six days a week, to accommodate every student\'s schedule.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="about">
      <div className="about__inner">

        {/* ════ LEFT – Content ════ */}
        <div className="about__content">

          {/* Eyebrow */}
          <div className="about__eyebrow">
            <span className="about__eyebrow-line" />
            <span>Who We Are</span>
          </div>

          <h2 className="about__title">
            A Legacy of Learning &amp;<br />
            <span className="about__title-accent">Knowledge Excellence</span>
          </h2>

          <p className="about__lead">
            Dr. SS Johl Library has been the intellectual heart of our institution
            for over 25 years — a sanctuary where curiosity is nurtured and
            scholarship thrives.
          </p>

          <p className="about__body">
            Founded with a vision to democratize access to knowledge, our library
            today stands as one of the most well-equipped academic libraries in the
            region. We curate resources that empower students, faculty, and researchers
            to achieve their full academic potential.
          </p>

          {/* Feature grid */}
          <div className="about__features">
            {FEATURES.map((f, i) => (
              <div className="about__feature" key={i}>
                <div className="about__feature-icon">
                  <i className={f.icon}></i>
                </div>
                <div className="about__feature-text">
                  <strong>{f.title}</strong>
                  <span>{f.desc}</span>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <a href="#notices" className="about__cta" onClick={(e) => {
            e.preventDefault();
            document.querySelector('#notices')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            <i className="fa-solid fa-arrow-right"></i>
            Explore Resources
          </a>
        </div>

        {/* ════ RIGHT – Image ════ */}
        <div className="about__image-wrap">

          {/* Decorative rings */}
          <div className="about__ring about__ring--outer" />
          <div className="about__ring about__ring--inner" />

          {/* Main image */}
          <div className="about__image-frame">
            <img src="https://images.unsplash.com/photo-1568667256549-094345857637?q=80&w=715&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="Dr. SS Johl Library interior" className="about__image" />
            <div className="about__image-overlay" />
          </div>

          {/* Floating badge – top left */}
          <div className="about__badge about__badge--top">
            <i className="fa-solid fa-award"></i>
            <div>
              <strong>Est. 1999</strong>
              <span>25+ Years of Excellence</span>
            </div>
          </div>

          {/* Floating badge – bottom right */}
          <div className="about__badge about__badge--bottom">
            <i className="fa-solid fa-star"></i>
            <div>
              <strong>50,000+</strong>
              <span>Books & Resources</span>
            </div>
          </div>

          {/* Decorative dots grid */}
          <div className="about__dots" />
        </div>

      </div>
    </section>
  );
}
